import { JSX } from "react";
import { useTranslation } from "react-i18next";

import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";

export function RequestQuoteSuccess({
  onClose,
}: {
  onClose: () => void;
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <DialogContent>
        <Typography sx={{ whiteSpace: "pre-wrap" }}>
          {t("AS:dialog.requestQuote.success.message")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>
          {t("AS:dialog.requestQuote.success.close")}
        </Button>
      </DialogActions>
    </>
  );
}
